<template>
  <div class="download">
    <banner title="下载APP" />
	<div class="download-content">
		<div class="download-cont">
			<div class="download-row">
				<div class="download-box">
					<img :src="tgrkyApple" alt="特格尔快药iPhone版" />
					<span> 特格尔快药iPhone版</span>
				</div>
				<div class="download-box">
					<img :src="tgrkyAndriod" alt="特格尔快药Andrio版" />
					<span>特格尔快药Andrio版</span>
				</div>
			</div>
			<div class="download-row">
				<div class="download-box">
					<img :src="tgrysApple" alt="特格尔医生iPhone版" />
					<span> 特格尔医生iPhone版</span>
				</div>
				<div class="download-box">
					<img :src="tgrysAndriod" alt="特格尔医生Andrio版" />
					<span>特格尔医生Andrio版</span>
				</div>				
			</div>
		</div>
	</div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
  	return{
		tgrkyApple: "",
		tgrkyAndriod: "",
		tgrysApple: "",
		tgrysAndriod: "",
	}
  },
  created() {
	this.getAppUrlData();
  },
  methods: {
	getAppUrlData(){
		this.$http
		  .get("api-homepage/home/homepage/filePath?fileName=&fileType")
		   .then(res =>{
			   let resData = res.data.data;
			   resData.forEach(item =>{
					if(item.fileType == "特格尔快药iPhone版"){
					   this.tgrkyApple = item.filePath
					}
					if(item.fileType == "特格尔快药Andrio版"){
					   this.tgrkyAndriod = item.filePath
					}
					if(item.fileType == "特格尔医生iPhone版"){
					   this.tgrysApple = item.filePath
					}
					if(item.fileType == "特格尔医生Andrio版"){
					   this.tgrysAndriod = item.filePath
					}																									
			   })
		})
	},
  }
  
};
</script>

<style lang="scss" scoped>
	.download {
	  width: 100%;
	  height: 100%;
	  background-color: #f5f5f5;
	}
	
	.download-content {
	  width: 1240px;
	  margin: 0 auto;
	  background-color: #fff;
	}
	.download-cont{
		width: 1000px;
		margin: 0 auto;
		padding: 60px 0;
	}
	.download-row{
		width: 680px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 30px;
		
		.download-box{
			display: flex;
			flex-direction: column;
			align-items: center;
		}
		img{
			width: 300px;
			height: 300px;
			margin-bottom: 8px;
		}
	}
</style>